import { render } from "./BurreauEquipeRenewHistory.vue?vue&type=template&id=35e98efa&scoped=true"
import script from "./BurreauEquipeRenewHistory.vue?vue&type=script&lang=js"
export * from "./BurreauEquipeRenewHistory.vue?vue&type=script&lang=js"

import "./BurreauEquipeRenewHistory.vue?vue&type=style&index=0&id=35e98efa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e98efa"]])

export default __exports__